<template>
  <div>
    <div class="flex-container">
      <div class="table">
        <div class="title">课题相关文档管理</div>
        <div>
          <el-form
            ref="queryForm"
            :model="listQuery"
            :inline="true"
            label-width="80px"
          >
            <el-select
              v-model="listQuery.step"
              placeholder="请选择文件所属阶段"
              clearable
              filterable
              size="small"
              style="width: 200px; margin-bottom: 15px"
              class="filter-item"
              @change="getList"
            >
              <el-option value="3" label="立项阶段" />
              <el-option
                value="4"
                label="中期检查"
                v-show="mxParams.group !== '3'"
              />
              <el-option value="6" label="结项阶段" />
              <el-option value="13" label="延期结项" />
              <el-option value="7" label="成果分享" />
            </el-select>
          </el-form>
        </div>
        <el-table
          v-loading="course.courseList.fileList.listLoading"
          :data="course.courseList.fileList.item"
          fit
          highlight-current-row
          :header-cell-style="tableHeaderColor"
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
        >
          <el-table-column
            label="操作"
            min-width="250"
            align="center"
            class-name="small-padding fixed-width"
          >
            <template slot-scope="scope">
              <!-- <el-button type="text" size="small">预览</el-button> -->
              <el-button
                size="mini"
                type="primary"
                @click="downloadFile(scope.row)"
                >下载</el-button
              >
              <el-button
                size="mini"
                type="primary"
                plain
                @click="toBz(scope.row)"
                style="margin-left: 5px"
                >添加备注</el-button
              >
              <el-popconfirm
                title="确定删除吗？"
                @confirm="deleteFile(scope.row.fileId)"
                v-if="mxParams.fwcy !== 0 || mxParams.fwgl !== 0"
              >
                <el-button
                  slot="reference"
                  type="danger"
                  size="mini"
                  style="margin-left: 5px"
                  >删除</el-button
                >
              </el-popconfirm>
              <!-- <el-button type="danger" size="mini" style="margin-left:5px">删除</el-button> -->
            </template>
          </el-table-column>
          <el-table-column
            label="课题属性"
            align="left"
            prop="groupName"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="上传人"
            align="left"
            prop="username"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="上传时间"
            align="left"
            prop="uploadTime"
            min-width="100px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="所属阶段"
            align="left"
            prop="stepName"
            min-width="100px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="文件名称"
            align="left"
            prop="fileName"
            min-width="300px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-link @click="openPreview(scope.row)" type="primary">
                {{ scope.row.fileName }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column
            label="文件大小"
            align="right"
            prop="fileSize"
            min-width="70px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">{{ scope.row.fileSize }}M</template>
          </el-table-column>

          <el-table-column
            label="备注"
            align="left"
            prop="remark"
            :show-overflow-tooltip="true"
          />
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <pagination
          v-show="course.courseList.fileList.count > 0"
          :total="course.courseList.fileList.count"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.pageSize"
          @pagination="getList"
        />
      </div>
      <div class="result">
        <div class="title">相关文档上传</div>
        <el-form ref="aForm" label-width="0px" style="text-align: center">
          <el-form-item label>
            <el-cascader
              v-model="path"
              :options="ktsxOptions"
              :props="{ expandTrigger: 'hover' }"
              @change="changePath"
              style="width: 500px"
              placeholder="请选择文档阶段路径"
            ></el-cascader>
          </el-form-item>
          <el-form-item label style="margin: 10px 0">
            <el-upload
              accept=".xls, .xlsx, .doc, .docx, .rar, .zip, .pdf, .txt, .ppt, .pptx"
              ref="upload"
              :action="action"
              :data="parm"
              :headers="headers"
              :on-change="handleChange"
              :before-upload="beforeUpload"
              :file-list="fileList"
              :show-file-list="false"
              :disabled="parm.text === ''"
            >
              <el-button
                type="primary"
                icon="el-icon-upload"
                plain
                :disabled="parm.text === ''"
                >附件</el-button
              >
              <div style="text-align: left">
                支持扩展名：.rar .zip .doc .docx .pdf .xlsx .xls .txt .ppt .pptx
                <br />规则一：由于网络宽带原因，限制最大文件为50M
                <br />规则二：两个或者两个以上的文件，支持压缩上传
                <br />规则三：大文件、大附件的需由管理组在客户端上传
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item
            label
            style="margin: 10px 0"
            v-show="
              mxParams.group === '3' &&
              mxParams.cstep !== '6' &&
              mxParams.cstep !== '13'
            "
          >
            <el-button type="primary" @click="saveAndToClosingReview"
              >保存并提交结项</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>

    <el-dialog
      :closeOnClickModal="false"
      title="编辑备注"
      :visible.sync="bzDialog"
      width="500px"
      top="100px"
      :modal="false"
    >
      <el-input
        v-model="file.remark"
        type="textarea"
        :rows="3"
        placeholder="请输入内容"
        show-word-limit
        maxlength="100"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveBz">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { formatMomentDate } from "@/utils/utils";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";
import Pagination from "@/components/Pagination";
import { getDictData } from "@/api/task.js";

export default {
  name: "courseFile",
  computed: {},
  props: ["mxParams"],
  components: { Pagination },
  data() {
    return {
      bzDialog: false,
      file: {},
      listQuery: {
        step: "",
        page: 1,
        pageSize: 50,
        courseFileInfo: {},
      },
      ktsxOptions: [],
      parm: {
        courseId: this.mxParams.id,
        group: this.mxParams.group,
        text: "",
        fileType: "1",
        force: 1,
      },
      fileList: [],
      action: window.g.apiUrl + "course/file/upload",
      headers: {
        "x-token": localStorage.getItem("token"),
      },
      value: [],
      options: [
        {
          label: "立项阶段",
          value: "1/立项阶段",
          children: [
            { label: "立项准备工作", value: "1/立项准备工作" },
            { label: "立项评审PPT", value: "2/立项评审PPT" },
            { label: "其他材料", value: "3/其他材料" },
          ],
        },
        {
          disabled: this.mxParams.group !== "3" ? false : true,
          label: "中期检查",
          value: "2/中期检查",
          children: [{ label: "中期检查附件", value: "1/中期检查附件" }],
        },
        {
          label: "结项阶段",
          value: "3/结项阶段",
          children: [
            { label: "结项准备工作", value: "1/结项准备工作" },
            { label: "成果报告（word）", value: "2/成果报告（word）" },
            { label: "成果物附件", value: "3/成果物附件" },
            { label: "结项评审PPT", value: "4/结项评审PPT" },
          ],
        },
        {
          label: "结项阶段（延期结项）",
          value: "4/结项阶段（延期结项）",
          children: [
            { label: "结项准备工作", value: "1/结项准备工作" },
            { label: "成果报告（word）", value: "2/成果报告（word）" },
            { label: "成果物附件", value: "3/成果物附件" },
            { label: "结项评审PPT", value: "4/结项评审PPT" },
          ],
        },
        {
          label: "成果物分享",
          value: "5/成果物分享",
          children: [
            { label: "成果分享安排", value: "1/成果分享安排" },
            { label: "成果分享PPT", value: "2/成果分享PPT" },
          ],
        },
      ],
      path: null,
    };
  },
  computed: {
    ...mapGetters(["course"]),
  },
  created() {
    this.listQuery.step = this.mxParams.flieStep;
    //课题属性
    getDictData("pmp_course_group", 1).then((res) => {
      if (res.code === 0) {
        // this.ktsxOptions = res.data;
        for (let index = 0; index < res.data.length; index++) {
          const element = res.data[index];
          let a = {
            disabled: this.mxParams.group === element.dictValue ? false : true,
            label: element.dictLabel,
            value: element.dictValue + "/" + element.dictLabel,
            children: this.options,
          };
          this.ktsxOptions.push(a);
        }
        if (this.mxParams.group == 1) {
          this.options.push({
            label: "其他",
            value: "7/其他",
            children: [{ label: "过程附件", value: "1/过程附件" }],
          });
        }
      }
    });

    this.getList();
  },
  mounted() {},
  methods: {
    getList() {
      // let fzr = this.listQuery.fzr ? this.listQuery.fzr.join(",") : null;

      const params = {
        page: this.listQuery.page,
        pageSize: this.listQuery.pageSize,
        step: this.listQuery.step,
        fileType: 1,
        courseId: this.mxParams.id,
        fileName: this.listQuery.wjmc,
      };

      this.$store
        .dispatch("course/fetchCourseFileListAction", {
          params,
        })
        .then((res) => {
          if (res.code == 0) {
          }
        });
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },

    toBz(file) {
      this.file = file;
      this.bzDialog = true;
    },
    saveBz() {
      const params = { fileId: this.file.fileId, remark: this.file.remark };
      if (this.file.remark === "") {
        this.$message.error("备注不能为空！");
        return;
      }
      this.$store
        .dispatch("course/fetchUpdateBzAction", {
          params,
        })
        .then((success) => {
          if (success.code === 0) {
            this.getList();
            this.bzDialog = false;
          } else {
            this.$message.error(success.msg);
          }
        });
    },
    openPreview(row) {
      const url = row.previewUrl;
      window.open(url);
    },
    downloadFile(row) {
      const filePath = row.serverPath;
      const fileName = row.fileName;
      const url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;
      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    deleteFile(fileId) {
      this.$store
        .dispatch("course/fetchDeleteFileAction", {
          fileId,
        })
        .then((success) => {
          if (success.code === 0) {
            this.$message.success("操作成功！");
            this.getList();
          } else {
            this.$message.error(success.msg);
          }
        });
    },
    beforeUpload(file) {
      // 验证文件大小
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error(file.name + "文件大小超出限制，请修改后重新上传");
        return false;
      }
    },
    handleChange(file, fileList) {
      if (file.status === "success") {
        if (file.response && file.response.code === 0) {
          this.$message.success("上传成功！");
          this.upDialog = false;
          this.getList();
        } else {
          this.$message.error("上传出错啦！错误信息：" + file.response.msg);
        }
      }
    },
    changePath(value) {
      this.parm.text = value;
    },
    saveAndToClosingReview() {
      this.$store
        .dispatch("course/saveAndToClosingReviewAction", {
          courseId: this.mxParams.id,
          step: this.mxParams.cstep === "10" ? 13 : 6,
        })
        .then((success) => {
          if (success.code === 0) {
            this.$emit("hideResultDialog");
          } else {
            this.$message.error(success.msg);
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.flex-container {
  width: 100%;
  height: 100%;
}
.tips {
  background-color: #d7d7d7;
  height: 44px;
  line-height: 44px;
  padding-left: 15px;
  margin: 15px 0;
}
.title {
  font-size: 15px;
  font-weight: bold;
  padding-left: 15px;
  line-height: 42px;
  height: 42px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 15px;
}
.table_count {
  color: #666;
  margin: 10px 15px;
}
.result {
  margin-bottom: 15px;
  .result_detail {
    font-size: 14px;
    background: #f3f3f3;
    line-height: 32px;
    padding-left: 15px;
    margin: 0 15px;
    color: #666;
  }
}

.content {
  margin-bottom: 30px;
  .content_item {
    line-height: 32px;
    font-size: 14px;
    margin-bottom: 15px;
    .content_title {
      font-weight: 700;
    }
    .content_text {
      background-color: #f3f3f3;
      padding: 5px 15px;
      margin-right: 15px;
    }
  }
}
</style>